import React, { memo } from 'react'
import { ColumnBanner } from '../../parts/column-banner/index'
import clsx from 'clsx'

export const ColumnLayout = memo(
  ({
    content,
    sideNav,
    isList = false // 一覧ページかどうかを判定するためのプロパティ追加
  }: {
    content: React.ReactNode
    sideNav: React.ReactNode
    isList?: boolean
  }) => {
    return (
      <div
        className={
          'max-w-[1200px] mx-auto lg:grid lg:grid-cols-[1fr_420px] lg:gap-x-10 lg:px-6 xl:px-0'
        }
      >
        {/* 左カラム - 常に716px */}
        <div className={'lg:max-w-[716px] px-6 lg:px-0 pb-8 lg:pb-16'}>
          {/* 一覧ページの場合、2カラムのグリッドレイアウト */}
          {isList ? (
            <div className={'grid grid-cols-1 md:grid-cols-2 gap-6'}>
              {content}
            </div>
          ) : (
            /* 詳細ページの場合、単一カラム */
            <div>{content}</div>
          )}
        </div>

        {/* 右カラム - 常に420px */}
        <aside className="px-6 lg:px-0 lg:max-w-[420px]">
          <div className="lg:sticky lg:top-[104px] lg:mb-10">
            <div className="lg:bg-white lg:px-10 lg:py-10 lg:mt-16 rounded-lg lg:border lg:border-gray lg:shadow-[0_4px_24px_rgba(199,189,168,.08)]">
              <div className={'grid gap-10'}>
                <div className={'hidden justify-center lg:flex'}>
                  <ColumnBanner />
                </div>
                {sideNav}
              </div>
            </div>
          </div>
        </aside>
      </div>
    )
  }
)

ColumnLayout.displayName = 'ColumnLayout'
